import { useState, Fragment } from "react";
import { useMutation } from "react-query";
import {
  Confirm,
  useNotify,
  useRecordContext,
  useDataProvider,
  ReferenceArrayInput,
  SimpleForm,
  AutocompleteInput,
} from "react-admin";
import { ButtonStrong } from "../../components/buttonStrong";
import { Box } from "@mui/material";

const PlanAddPrice = (props) => {
  return (
    <SimpleForm record={{ prices: [] }} toolbar={false}>
      <ReferenceArrayInput source="prices" reference="prices">
        <AutocompleteInput
          filterToQuery={(searchText) => ({ product_name: `${searchText}` })}
          {...props}
        />
      </ReferenceArrayInput>
    </SimpleForm>
  );
};

const AddPriceButton = () => {
  const record = useRecordContext();
  const [open, setOpen] = useState(false);
  const [price, setPrice] = useState("");
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const { mutate, isLoading } = useMutation(() =>
    dataProvider.addPriceToPlan(record.id, price.trim(), notify)
  );

  const handleClick = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);
  const handleConfirm = () => {
    notify("Add price to Plan");
    mutate();
    setOpen(false);
  };

  const confirm_message = (
    <>
      <Box>
        Are you sure you want to add price to Plan: {record.name} (#{record.id}
        )?
      </Box>
      <Box>
        <PlanAddPrice onChange={(value) => setPrice(value)} fullWidth />
      </Box>
    </>
  );
  return (
    <Fragment>
      <ButtonStrong
        label="Add price"
        onClick={handleClick}
        color="inherit"
        size="small"
        sx={{ flexShrink: 0 }}
      />
      <Confirm
        isOpen={open}
        loading={isLoading}
        title="WARNING! READ THIS"
        content={confirm_message}
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
        sx={{
          "*": {
            paddingBottom: "5px",
          },
        }}
        confirm={"YES"}
        cancel={"NO"}
        confirmColor="green"
      />
    </Fragment>
  );
};

export default AddPriceButton;
